import Layout from 'layout';
import { AdjustmentViewList } from 'features/Project/pages';
import { LayoutProvider } from '../layout/context/layoutcontext';

function ProjectAdjustmentViewListPage() {
  return (
    <LayoutProvider>
      <Layout
        style={{
          maxHeight: 'calc(100vh - 9rem)',
          overflowY: 'auto',
          borderRadius: '12px',
          border: '1px solid var(--surface-border)',
          backgroundColor: 'white',
        }}
      >
        <AdjustmentViewList />
      </Layout>
    </LayoutProvider>
  );
}

export default ProjectAdjustmentViewListPage;
